import axios from "axios";

export default {
  updateCostom(context, payload) {
    context.commit("updateCostom", payload);
  },
  emptyCustomInfo(context) {
    context.commit("emptyCustomInfo");
  },
  updateComponentCode(context, payload) {
    context.commit("updateComponentCode", payload);
  },
  updataCanvasDataUrl(context, payload) {
    context.commit("updataCanvasDataUrl", payload);
  },
  getPicSendUrl(context) {
    axios({
      url: context.getters.getCustomGlobalUrl + "url/generate",
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        let imgData = {
          url: response.data.data.url,
          fileName: response.data.data.fileName,
        };
        context.dispatch("pushImg", imgData);
      })
      .catch((e) => {
        alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
      });
  },
  pushImg(context, payload) {
    axios({
      url: payload.url,
      method: "put",
      data: context.getters.getCanvasDataUrl,
      headers: {
        "Content-Type": "text/plain",
      },
    })
      .then(() => {
        context.commit("updataImageUrl", payload.url.split("?")[0]);
      })
      .catch((e) => {
        alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
      });
  },
};
